import { IPageInfo } from '../../../models/page.types';
import type {
  ExamTaskGroupSolutions,
  ExamTaskGroupSolutionsProgressData,
} from '../../../pages/Assessment/Assessment.types';

export interface ExamTaskGroupSolutionsResponse {
  pageInfo: IPageInfo;
  list: ExamTaskGroupSolutions[];
  examinersHaveScoreToSendBack: { [examinerId: string]: boolean };
  progress: ExamTaskGroupSolutionsProgressData;
}

export enum Status {
  New,
  Open,
  Assessed,
  Closed,
}

export enum AssessmentSessionProcessTypeId {
  Training,
  Qualification,
  Scoring,
  Control,
}

export enum ExamTaskGroupSolutionStatus {
  Available,
  NoneExceededLimits,
  NoneNoMoreSolutions,
  NoneExaminerBlocked,
  NoneProcessFinished,
  NoneSessionClosed,
}

export const ExamTaskGroupSolutionStatusDisablingDownloading = [
  ExamTaskGroupSolutionStatus.NoneExaminerBlocked,
  ExamTaskGroupSolutionStatus.NoneProcessFinished,
  ExamTaskGroupSolutionStatus.NoneSessionClosed,
  ExamTaskGroupSolutionStatus.NoneExceededLimits,
  ExamTaskGroupSolutionStatus.NoneNoMoreSolutions,
];

export const assessmentSessionProcessOrder: AssessmentSessionProcessTypeId[] = [
  AssessmentSessionProcessTypeId.Training,
  AssessmentSessionProcessTypeId.Qualification,
  AssessmentSessionProcessTypeId.Scoring,
];

export interface ExamTaskGroupSolution {
  id: string;
  sheetId: string;
  examinerId?: string;
  examTaskGroupSolutionScoreId?: string;
}

export interface ExamTaskSolutionNavigationIds {
  firstId: string | null;
  prevId: string | null;
  nextId: string | null;
  lastId: string | null;
}

export interface ExamTaskSolutionNavigationResponse {
  current: ExamTaskGroupSolution | null;
  all: ExamTaskSolutionNavigationIds;
  notAssessed: ExamTaskSolutionNavigationIds;
  cards: ExamTaskGroupSolution[];
}
